import { ca } from '@cian/analytics';

import { TTrackingParamsType } from '../../types/page/trackingParamsType';

export const trackGoToMyOffersClick = ({ dealType, cianSource, siteType }: TTrackingParamsType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'RentContract',
    action: 'Click',
    label: 'GoToMyOffers',
    page: {
      pageType: 'OnlineRentContract',
      siteType,
      extra: {
        dealType,
        cian_source: cianSource,
      },
    },
  });
};
